import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as lightboxAccessibility from './scripts/lightbox-accessibility';
lightboxAccessibility.init();

import Collapse from 'bootstrap/js/dist/collapse';

import * as playVideo from './scripts/play-video';
playVideo.init();

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as imgContentSlider from './scripts/img-content-slider';
imgContentSlider.init();

import * as imageContentSlider from './scripts/image-content-slider';
imageContentSlider.init();

import * as contentSlider from './scripts/content-slider';
contentSlider.init();

import * as cardTeaserSlider from './scripts/card-teaser-slider';
cardTeaserSlider.init();

import * as imgTeaserSlider from './scripts/img-teaser-slider';
imgTeaserSlider.init();


import * as rotateCircle from './scripts/rotate-circle';
rotateCircle.init();

import * as formValidation from '@elements/form-validation';
formValidation.init({
    trigger: { event: 'true'}
});

import * as hashCashFormValidation from './scripts/hash-cash-form-validation';
hashCashFormValidation.init();

import * as googleMap from "./scripts/google-map";
googleMap.init();

import * as parallax from "./scripts/parallax";
parallax.init();


import * as panoramaViewer from "./scripts/panorama-viewer";
panoramaViewer.init();

import * as circleAnimation from './scripts/circle-animation';
circleAnimation.init();

import * as lightboxTracking from './scripts/lightbox-tracking';
lightboxTracking.init();

import * as datepickerRange from "@elements/datepicker-range";
datepickerRange.init();

import * as accreditationForm from './scripts/accreditation-form';
accreditationForm.init();

import * as requireOneInput from './scripts/require-one-input';
requireOneInput.init();

import * as scrollToTop from './scripts/scroll-to-top';
scrollToTop.init();